import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { showMessage } from '../../redux/actions/common-message/message-action';
import { activateLoader, disableLoader } from '../../redux/actions/ui-trigger/ui-trigger-action';
import {
  Container,
  ADD_ICON_IMAGE,
  Header,
  ADD_NEW_CARD_MODAL,
  FieldContainer,
  ButtonContainer,
  NOTES,
  CardNumberContainer
} from '../../screens/manage-payment/manage-payment.style';
import { OutlinedTextFields } from '../../components/material-textField/texField';
import BoxDropdown from '../../components/form-controls/outlinedDropdown';
import { Field, reduxForm, getFormValues, change, untouch } from 'redux-form';
import {
  required,
  exactLength3,
  stripeCardExpirValidation,
  stripeCardNumberValidation
} from '../../utils/validation/index';
import { normalizeAll, r_maxLength, r_onlyNumbers } from '../../utils/validation/restrictions';
import { addNewCard } from '../../redux/actions/manage-payment/manage-payment';
import { findDebitCardType, encryptDataWithSignature, isEuCorridor } from '../../utils/library';
import { ADD_CARD_FIELDS, CARD_ICON } from '../../utils/constants';
import CommonButton from '../common-button/CommonButton';
import { getCardNetwork } from './utils';
import { ALL_CARDS_ICON, VISA_MASTER_ICON } from '@Images';
import { logEventV2 } from '@Utils/events/logUserEvents';
import {
  EVENT_ROUTE_KEYS,
  EventButtonType,
  EventNamesV2,
  FLOW_TYPE
} from '@Utils/events/eventsConstants';

const FORMNAME = 'add-new-card';

class AddNewCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cardType: undefined,
      showSpinner: false,
      card_network: '',
      cardNetworks: []
    };
    this.formID = FORMNAME;
  }

  UNSAFE_componentWillReceiveProps(prevProps) {
    const { showCard, dispatch } = this.props;
    if (prevProps.showCard !== showCard) {
      ADD_CARD_FIELDS.forEach((field) => {
        dispatch(change(this.formID, field, ''));
        dispatch(untouch(this.formID, field));
      });
      this.setState({ cardType: undefined, cardNetworks: [], card_network: '' });
    }
  }

  setSpinner = (value) => this.setState({ showSpinner: value });

  submit = async (e) => {
    const { getAllformVal, onClose, user_preferred_type, dispatch } = this.props;
    const expiry = getAllformVal['expiry_date'].split('/');
    let data = {
      card_number: getAllformVal['card_number'].replace(/ /g, ''),
      cvc: getAllformVal['cvc'],
      expiry_month: expiry[0],
      expiry_year: expiry[1]
    };

    if (user_preferred_type) data = { ...data, user_preferred_type };
    if (isEuCorridor(this.props.user_session?.country_code))
      data = {
        ...data,
        card_network:
          getAllformVal['card_network']?.toLowerCase() || this.state?.cardType?.toLowerCase()
      };
    const body = encryptDataWithSignature(JSON.stringify(data));
    this.setSpinner(true);
    const result = await this.props.addNewCard(body, onClose);
    this.setSpinner(false);
    if (result) {
      this.logEvents();
      dispatch(change(this.formID, 'card_network', ''));
      this.props.success && this.props.success(result.success);
    }
  };

  getNetworks = async (cardNumber) => {
    if (cardNumber.length === 16) {
      const response = await getCardNetwork(cardNumber);
      return response || [];
    } else return [];
  };

  logEvents = () => {
    const { getAllformVal } = this.props;
    const eventProperty = {
      type: EventButtonType.BUTTON,
      pageName: EVENT_ROUTE_KEYS.ManagePaymentOptions,
      ctaName: 'Card Added',
      flowType: FLOW_TYPE.MANAGE_PAYMENT_OPTIONS
    };

    if (getAllformVal) {
      const data = {
        card_number: getAllformVal['card_number']?.replace(/ /g, '').slice(-5),
        cardType: this.state.cardType
      };

      Object.assign(eventProperty, data);
    }
    logEventV2(EventNamesV2.CTA_CLICKED, eventProperty);
  };

  fetchCardType = async () => {
    const { getAllformVal, dispatch } = this.props;
    const cardNumber = getAllformVal?.card_number?.replace(/ /g, '');
    if (cardNumber) {
      const cardType = findDebitCardType(cardNumber);
      if (isEuCorridor(this.props.user_session?.country_code)) {
        const cardNetworks = await this.getNetworks(cardNumber);
        this.setState({
          cardType,
          cardNetworks
        });
        if (cardNetworks.length === 1) {
          dispatch(change(this.formID, 'card_network', cardNetworks[0].value));
        } else {
          dispatch(change(this.formID, 'card_network', ''));
        }
      } else {
        this.setState({
          cardType
        });
      }
    }
  };

  render() {
    const {
      handleSubmit,
      content,
      showCard,
      extraNote,
      height = '400px',
      getAllformVal
    } = this.props;
    const { cardType } = this.state;
    const cardBaseImgaeSizeArr = ['DISCOVER', 'AMERICAN_EXPRESS'];
    const isEuCorridorFlag = isEuCorridor(this.props.user_session?.country_code);
    const isValidCardNumber =
      getAllformVal?.card_number?.replace(/ /g, '')?.length === 16 &&
      this.state?.cardNetworks?.length > 0;

    return (
      <ADD_NEW_CARD_MODAL height={height} $showCard={showCard}>
        <Container className="add-padding-card">
          <div className="inside-div">
            <Header id="debit-card-header" fontSize={'18px'} $paddingTop={'0px'}>
              {content.heading}
            </Header>
            <div className="card-types">
              {isEuCorridorFlag ? (
                <img
                  alt="all card"
                  src={ALL_CARDS_ICON}
                  style={{ height: '24px', width: '105px' }}
                />
              ) : (
                <img
                  alt="all card"
                  src={VISA_MASTER_ICON}
                  style={{ height: '23px', width: '71px' }}
                />
              )}
            </div>
          </div>
          <form className="add-card-form" id={this.formID} onSubmit={handleSubmit(this.submit)}>
            <CardNumberContainer $showNetwork={isEuCorridorFlag}>
              <FieldContainer className="fixed-height">
                <div className="field card_number">
                  <Field
                    name={'card_number'}
                    type="text"
                    component={OutlinedTextFields}
                    validate={[required, stripeCardNumberValidation]}
                    placeholder={'Card number'}
                    isEditable={true}
                    showErrorIcon={true}
                    inputTypeField="debit card"
                    onKeyUp={this.fetchCardType}
                    maxWidth={'100%'}
                    customMargin={'8px 0px'}
                    cardImage={
                      cardType &&
                      !isEuCorridorFlag && (
                        <ADD_ICON_IMAGE
                          src={CARD_ICON[`${cardType}_LITE`]}
                          style={{
                            width: cardBaseImgaeSizeArr.includes(cardType) ? '77px' : '69px'
                          }}
                        />
                      )
                    }
                  />
                </div>
              </FieldContainer>
              {isEuCorridorFlag && (
                <FieldContainer className="fixed-height network-dropdown">
                  <div className="field">
                    <Field
                      bindToThisObject={getAllformVal?.card_network}
                      name={'card_network'}
                      component={BoxDropdown}
                      isSearchable={false}
                      placeholder={'Network'}
                      isEditable={true}
                      onDropdownChange={(e) => {
                        this.setState({ ...this.state, card_network: e.value });
                      }}
                      width="100%"
                      staticValues={this.state?.cardNetworks}
                      showImage={true}
                      showCards={true}
                      disabled={!isValidCardNumber}
                    />
                  </div>
                </FieldContainer>
              )}
            </CardNumberContainer>

            <FieldContainer paddingTop={'0px'} className={'add-spacing fixed-height'}>
              <Field
                name={'expiry_date'}
                type="text"
                component={OutlinedTextFields}
                validate={[required, stripeCardExpirValidation]}
                placeholder={'Expiry date (MM/YY)'}
                isEditable={true}
                maxWidth={'100%'}
                customMargin={'8px 0px'}
                showErrorIcon={true}
                normalize={r_maxLength(5)}
              />
              <Field
                id="cvc-tooltip"
                name={'cvc'}
                type="password"
                component={OutlinedTextFields}
                validate={[required, exactLength3]}
                placeholder={'Security code'}
                normalize={normalizeAll([r_onlyNumbers, r_maxLength(3)])}
                isEditable={true}
                maxWidth={'100%'}
                customMargin={'8px 0px'}
                showErrorIcon={true}
                tooltip={'3-digit security code usually found on the back of your card.'}
                tollTipSize={{ height: '20px', width: '20px' }}
              />
            </FieldContainer>
            {extraNote && (
              <NOTES id="note1" className={'add-margin'} leftAlign>
                {extraNote}
              </NOTES>
            )}
            <ButtonContainer>
              <CommonButton
                id="manage-payment-button"
                isLoading={this.state.showSpinner}
                disabled={this.state.showSpinner}
                text="Add your card"
                loaderHeight={40}
                height={50}
                width={335}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubmit(this.submit)();
                }}
              />
            </ButtonContainer>
          </form>
          <NOTES className="add-margin" id="notes">
            All transactions are secure and encrypted.
          </NOTES>
        </Container>
      </ADD_NEW_CARD_MODAL>
    );
  }
}

AddNewCard.propTypes = {
  getAllformVal: PropTypes.any,
  onClose: PropTypes.func,
  addNewCard: PropTypes.func,
  handleSubmit: PropTypes.func,
  content: PropTypes.func,
  extraNote: PropTypes.string,
  success: PropTypes.func,
  user_preferred_type: PropTypes.string,
  showCard: PropTypes.bool,
  dispatch: PropTypes.func,
  height: PropTypes.string,
  user_session: PropTypes.object
};

const createReduxForm = reduxForm({
  form: FORMNAME
});

const ReduxFormAddNewCard = createReduxForm(AddNewCard);

function mapStateToProps(reduxState) {
  const {
    rootReducer: {
      userSessionReducer: { user_session }
    }
  } = reduxState;

  const getAllformVal = getFormValues(FORMNAME)(reduxState);

  return {
    user_session,
    getAllformVal
  };
}

export default connect(mapStateToProps, {
  showMessage,
  activateLoader,
  disableLoader,
  addNewCard
})(ReduxFormAddNewCard);
